import { Routes } from '@angular/router';

export const authRoutes: Routes = [
  {
    // Dedicated landing route for the AAD redirect callback.
    // AuthCallback calls handleRedirectObservable(), then
    // navigateToLoginRequestUrl returns the user to their original destination
    // via Angular Router. Logout callbacks return to /login after processing.
    path: 'auth',
    loadComponent: () =>
      import('./pages/auth-callback/auth-callback').then((module) => module.AuthCallback),
    data: { titleKey: 'routes.auth' },
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login').then((module) => module.Login),
    data: { titleKey: 'routes.login' },
  },
];
